import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>About Us</h4>
          <p>
          पात्रता की जांच करने और सरकारी योजनाओं के लिए आवेदन करने के लिए आपका वन-स्टॉप समाधान</p>
        </div>
        
        <div className="footer-section">
          <h4>More About ByteEdu</h4>
          <ul>
            <li><a href="https://byte-edu-tech.netlify.app/">Tech</a></li>
            <li><a href="https://byte-edu-learning-platform.netlify.app/">Learning Platform</a></li>
            <li><a href="https://www.linkedin.com/company/byteedu-learning-platform/people/?viewAsMember=true">Linkedin</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
        <hr/>
          <h4>Contact Info</h4>
          <p><b style={{color:'white'}}>Email</b>: byteedu@proton.me</p>
          <p><b style={{color:'white'}}>Phone</b>: +91 9829296192</p>
          <p><b style={{color:'white'}}>Website</b>: <a href="https://byte-edu-tech.netlify.app/">ByteEdu Tech</a></p>
          <p><b style={{color:'white'}}>Address</b>: Jaipur, Rajasthan, India</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()}  Upkartam Government Schemes Portal. All Rights Reserved.</p>
        <p>Product By : ByteEdu Tech</p>
      </div>
    </footer>
  );
};

export default Footer;
